module.exports = __webpack_public_path__ + "8581b8a36b71883cfc869bf2e674f98a.svg";